const UploadArrow = ({ width = '24', height = '24', ...props }) => (
	<svg
		{...props}
		width={width}
		height={height}
		viewBox="0 0 24 24"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<g id="upload">
			<path
				id="Vector"
				d="M18 3L6 3M12 21L12 7M12 7L7 12M12 7L17 12"
				stroke="currentColor"
				strokeWidth="2"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</g>
	</svg>
)

export default UploadArrow
